/* eslint-disable jsx-a11y/no-static-element-interactions -- onClick handlers on div wrappers for event propagation control */
import React, { useEffect, useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { Spin, Table, Empty } from 'antd-v5';
import { useQuery } from 'react-query';
import { LoadingOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'antd-v5';
import { postRequest } from '../../../../core/apiRequests';
import { notificationSuccess } from '../../../../core/actions';
import { listReminders, normalizeReminder } from '../../../../services/reminders';
import { sourceCalcCentral } from './logicFunctions';
import MessageConfigToday from './MessageConfigToday';
import { associateNameFormat } from '../../../../utils';
import SnoozeModal from '../Reminders/children/SnoozeModal';
import ReminderModal from '../../../Layout/Modals/EditReminderModal';
import DropDownSelect from '../../../Layout/DropdownSelect';
import PopConfirm from '../../../Layout/PopConfirm';
import Modal from '../../../CustomizedAntDesign/Modal/Modal';
import '../today.css';

const TodayAutoReminders = props => {
  const [isShown, setIsShown] = useState('');
  const [showSnoozeModal, setShowSnoozeModal] = useState(false);
  const [editReminderModal, setEditReminderModal] = useState(false);
  const [checkCustomReminder, setCheckCustomReminder] = useState(false);
  const [assignPopup, setAssignPopup] = useState(false);
  const [dismissPopup, setDismissPopup] = useState(false);
  const [completePopup, setCompletePopup] = useState(false);
  const [associate, setAssociate] = useState();
  const [selectedAction, setSelectedAction] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [singleRem, setSingleRem] = useState();

  useEffect(() => {
    if (selectedAction.length === 1) {
      const [action] = selectedAction;
      setCheckCustomReminder(sourceCalcCentral(action) === 'Manual Reminder');
    } else {
      setCheckCustomReminder(false);
    }
  }, [selectedAction]);

  const rowClickHandler = item => {
    setSingleRem([item]);
  };

  const {
    data,
    refetch: refetchTodayActions,
    isFetching: isTodayActionsLoading,
  } = useQuery(
    ['today-actions'],
    async () => {
      try {
        const query = {
          limit: 10,
          offset: 0,
          statuses: ['active'],
          fromDueDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
          associateIds: [props.auth.userId],
        };
        const response = await listReminders(query);
        if (response?.data) {
          return response.data.map(normalizeReminder);
        }
        return [];
      } catch (error) {
        console.error('Error fetching reminders:', error);
        return [];
      }
    },
    {
      refetchOnWindowFocus: false,
      initialData: [],
      enabled: !!(props.auth.authenticated && props.auth.merchantId),
    },
  );

  // 04/05 THIS CURRENTLY USES CLIENT STORE_ID. IT NEEDS TO EVENTUALLY USE THE ASSOCIATE STORE ID
  // associate store_id with more than one associated store is 0. We do not have a way of knowing default store yet for associates.
  const saveSelected = () => {
    const selected = selectedAction;
    const reqObj = {
      params: ['today', props.auth.merchantId, 'save'],
      data: { selected },
      query: {
        storeId: props.auth.storeId,
        associateId: props.auth.userId,
        createdBy: `${props.auth.firstName || ''} ${props.auth.lastName || ''}`,
      },
    };

    (async () => {
      const res = await postRequest(reqObj);
      if (res) {
        setSelectedAction([]);
        setSelectedRowKeys([]);
        refetchTodayActions();
        notificationSuccess('Reminder(s) Complete!');
      }
    })();
  };

  const handleClickDismiss = () => {
    const hasRepeating = selectedAction.some(item => item.repeats);
    if (hasRepeating) {
      setCompletePopup(true);
    } else {
      setDismissPopup(true);
    }
  };

  const expiresOn = expiresOnDate => {
    return moment(expiresOnDate).diff(moment().startOf('day'), 'days');
  };

  useEffect(() => {
    if (!props?.messaging?.client?.reminderId) {
      refetchTodayActions();
    }
  }, [props?.messaging?.client?.reminderId]);

  const columns = useMemo(
    () => [
      {
        title: 'Due Date',
        dataIndex: 'dueDate',
        key: 'dueDate',
        render: (t, record) => {
          if (t) {
            const formatted = moment(t).format('MM/DD/YYYY');
            if (record.expiresOnDate) {
              const daysLeft = expiresOn(record.expiresOnDate);
              if (daysLeft <= 0) {
                return (
                  <div className="flex-col-left">
                    {formatted}
                    <span className="fs-12 fw-400 gray">Expires today</span>
                  </div>
                );
              }
              if (daysLeft === 1) {
                return (
                  <div className="flex-col-left">
                    {formatted}
                    <span className="fs-12 fw-400 gray">Expires tomorrow</span>
                  </div>
                );
              }
              return (
                <div className="flex-col-left">
                  {formatted}
                  <span className="fs-12 fw-400 gray">Expires in {daysLeft} days</span>
                </div>
              );
            }
            return formatted;
          }
          return null;
        },
      },
      {
        title: 'Client Name',
        key: 'clientName',
        render: (_, record) => <Link to={`/Clients?client=${record.client?.id}`}>{record.client?.name}</Link>,
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Source',
        key: 'source',
        render: (_, record) => sourceCalcCentral(record),
      },
      {
        title: 'Reassign',
        dataIndex: 'reassigned_by',
        key: 'reassigned_by',
        align: 'center',
        render: (_, record) => (
          <div className="align-center" style={{ maxHeight: '34px' }}>
            <FontAwesomeIcon
              icon={['far', 'pencil']}
              onClick={e => {
                e.stopPropagation();
                setAssignPopup(record);
              }}
              className="pointer gray"
            />
          </div>
        ),
      },
      {
        title: 'Message',
        dataIndex: 'message',
        key: 'message',
        align: 'center',
        render: (_, record) => (
          <div className="align-center pos-rel" style={{ maxHeight: '34px' }} onClick={e => e.stopPropagation()}>
            <MessageConfigToday
              keyVar={Math.floor(Math.random() * record.id)}
              msgObj={record}
              setShowPopConfirm={props.setShowPopConfirm}
              initiateTemplates={props.initiateTemplates}
              setIsShown={setIsShown}
              isShown={isShown}
              setSelectedClient={props.setSelectedClient}
            />
          </div>
        ),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        render: (_, record) => {
          if (!record.completeDate) {
            if (moment().isAfter(moment(record.dueDate).add(1, 'day'))) {
              return <span className="today-status-badge overdue">OVERDUE</span>;
            }
            return <span className="today-status-badge active">ACTIVE</span>;
          }
          return null;
        },
      },
    ],
    [props.setShowPopConfirm, props.initiateTemplates, props.setSelectedClient, isShown],
  );

  const rowSelection = {
    selectedRowKeys,
    columnWidth: 48, // Match Appointments table checkbox column width
    onChange: (newSelectedRowKeys, newSelectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedAction(newSelectedRows);
    },
  };

  const assignAssociate = () => {
    setAssignPopup(false);
    let reqObj;
    if (singleRem) {
      reqObj = {
        params: ['today', props.auth.merchantId, 'assignAssociate'],
        data: { selectedAction: singleRem },
        query: {
          assignedAssociate: associate,
          storeId: props.auth.storeId,
          associateId: props.auth.userId,
        },
      };
    } else {
      reqObj = {
        params: ['today', props.auth.merchantId, 'assignAssociate'],
        data: { selectedAction },
        query: {
          assignedAssociate: associate,
          storeId: props.auth.storeId,
          associateId: props.auth.userId,
        },
      };
    }
    (async () => {
      const res = await postRequest(reqObj);
      if (res) {
        setSelectedAction([]);
        setSelectedRowKeys([]);
        refetchTodayActions();
        setSingleRem([]);
        notificationSuccess('Reminder(s) Assigned!');
        setAssociate(props.auth.userId);
      }
    })();
  };

  const dismissSelected = (deleteAll = false) => {
    const reqObj = {
      params: ['today', props.auth.merchantId, 'dismissSelected'],
      query: {
        associateName: associateNameFormat(props.auth.firstName, props.auth.lastName),
        associateId: props.auth.userId,
      },
      data: {
        selectedAction: selectedAction.map(item => item.id),
        repeats: deleteAll ? 0 : 1,
      },
    };
    (async () => {
      const responseObj = await postRequest(reqObj);
      if (responseObj) {
        setSelectedAction([]);
        setSelectedRowKeys([]);
        setDismissPopup(false);
        setCompletePopup(false);
        refetchTodayActions();
        notificationSuccess(`Reminder(s) ${deleteAll ? 'Deleted' : 'Dismissed'}!`);
      }
    })();
  };

  return (
    <div className="m-btm-35" data-testid="reminders__today--section">
      <div className="flex-row items-center justify-between m-btm-10">
        <span className="fs-15 fw-500">Reminders</span>
        {selectedAction.length > 0 ? (
          <div className="cb-link-btn-group cb-link-btn-group--wide">
            {checkCustomReminder && (
              <Button type="link" className="cb-link-btn-action" onClick={() => setEditReminderModal(true)}>
                <FontAwesomeIcon icon={['far', 'pencil']} />
                Edit
              </Button>
            )}
            <Button type="link" className="cb-link-btn-action" onClick={() => setAssignPopup(true)}>
              <FontAwesomeIcon icon={['far', 'user']} />
              Assign Associate
            </Button>
            <Button type="link" className="cb-link-btn-action cb-link-btn-action--icon-lg" onClick={saveSelected}>
              <FontAwesomeIcon icon={['far', 'check-circle']} />
              Complete
            </Button>
            <Button type="link" className="cb-link-btn-action" onClick={handleClickDismiss}>
              <FontAwesomeIcon icon={['far', 'eraser']} />
              Dismiss
            </Button>
            <Button type="link" className="cb-link-btn-action" onClick={() => setShowSnoozeModal(true)}>
              <FontAwesomeIcon icon={['far', 'alarm-clock']} />
              Snooze
            </Button>
          </div>
        ) : (
          <Link to="/all-reminders" id="ViewAllReminders">
            <Button type="link" className="cb-link-btn">
              View All
            </Button>
          </Link>
        )}
      </div>

      {isTodayActionsLoading ? (
        <div className="w-100-P flex-col-center m-top-10">
          <Spin tip="Loading..." size="large" indicator={<LoadingOutlined spin />}>
            <div
              style={{
                padding: 50,
                background: 'rgba(0, 0, 0, 0.1)',
                borderRadius: 8,
              }}
            />
          </Spin>
        </div>
      ) : (
        <>
          <Table
            className="today-table"
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={false}
            rowSelection={rowSelection}
            onRow={record => ({
              onClick: () => rowClickHandler(record),
              style: { cursor: 'pointer' },
              'data-testid': 'reminders__table--row',
            })}
            locale={{
              emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Reminders" />,
            }}
          />
        </>
      )}

      {editReminderModal && (
        <ReminderModal
          open={editReminderModal}
          reminder={selectedAction?.[0] ?? {}}
          allAssoc={props.allAssoc}
          onClose={() => setEditReminderModal(false)}
          setReload={() => {
            setSelectedAction([]);
            setSelectedRowKeys([]);
            refetchTodayActions();
          }}
        />
      )}
      <SnoozeModal
        openModal={showSnoozeModal}
        setOpenModal={setShowSnoozeModal}
        merchantId={props.auth.merchantId}
        actions={selectedAction}
        refresh={() => {
          setSelectedAction([]);
          setSelectedRowKeys([]);
          refetchTodayActions();
        }}
      />

      {assignPopup ? (
        <PopConfirm
          popStyle={{
            width: '380px',
          }}
          confirmButtonText="SAVE"
          cancelButtonText="CANCEL"
          confirm="Assign Associate"
          description={[
            <div key="primary" className="align-left m-top-10" style={{ height: '175px' }}>
              <span className="dropDownDescriptionText">Assign an Associate</span>
              <DropDownSelect
                classProps="mq-w-200 w-295 align-left m-top-8"
                options={props.allAssoc.map(asc => ({
                  label: asc.fullName ? asc.fullName : `${asc.first_name || ''} ${asc.last_name || ''}`,
                  value: asc.id,
                }))}
                placeholder="Select an Associate..."
                value={associate}
                onChange={obj => {
                  setAssociate(obj.value);
                }}
              />
            </div>,
          ]}
          noButtonDisable
          onCancel={() => setAssignPopup(false)}
          onConfirm={assignAssociate}
        />
      ) : null}
      {dismissPopup ? (
        <PopConfirm
          popStyle={{
            width: '380px',
          }}
          customHeaderContent="fs-16 align-center"
          confirmButtonText="Dismiss"
          cancelButtonText="Cancel"
          confirm="Dismiss Selected Reminders"
          description="These reminders will be dismissed from your list.  If you continue, these reminders will be permanently removed from your profile."
          noButtonDisable
          onCancel={() => setDismissPopup(false)}
          onConfirm={dismissSelected}
        />
      ) : null}

      <Modal
        open={completePopup}
        onCancel={() => setCompletePopup(false)}
        footer={null}
        width={348}
        destroyOnClose
        closable
        centered
        className="cb-reminders-modal"
      >
        <div className="cb-reminders-modal__body">
          <h3>Dismiss reminders</h3>
          <p>This reminder repeats. Would you like to dismiss this occurrence or delete it?</p>
        </div>
        <div className="flex-row-center m-top-15" style={{ gap: '12px' }}>
          <Button size="large" onClick={() => dismissSelected(false)}>
            Dismiss
          </Button>
          <Button type="primary" size="large" onClick={() => dismissSelected(true)}>
            Delete All
          </Button>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  messaging: state.messaging,
});
export default connect(mapStateToProps, {})(TodayAutoReminders);
